import React, { useCallback, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import "./groupsSetup.scss";
import AQCheckinTable from "../../../../ReuseableComponents/Table/Table";
import { GroupTableColumns } from "./GroupSetup.utils";
import ModalForm from "./GroupForm/GroupForm";
import { getGroupsList } from "../../../../../apis/groupApis/getGroupsList";
import { deleteGroup } from "../../../../../apis/groupApis/deleteGroup";
import { Modal, Button } from "reactstrap";
import AQModal from "../../../../ReuseableComponents/AQModal/Modal/Modal";
import { toast } from "react-toastify";
import Loader from "../../../../ReuseableComponents/Loader/Loader";

const GroupSetup: React.FC = () => {
  const [modal, setModal] = useState(false);
  const [showModal, setshowModal] = useState(false);
  const [userClickData, setUserClickData] = useState({
    id: 0,
    type: "",
  });
  const { data: groupMeta } = useQuery(["getGroupList"], getGroupsList, {
    refetchInterval: 1000,
  });
  const toggle = () => {
    setUserClickData({
      id: 0,
      type: "",
    });
    setModal(!modal);
  };

  const onDelete = useCallback(
    (id: number) => {
      setUserClickData({
        id: id,
        type: "delete",
      });
      setshowModal(!showModal);
    },
    [showModal, setshowModal]
  );
  const onEdit = useCallback(
    (id: number) => {
      setUserClickData({
        id: id,
        type: "edit",
      });
    },
    [showModal, setshowModal]
  );

  const onConfirm = () => {
    if (userClickData?.type === "delete") {
      deleteGroup(userClickData?.id)
        .then((resp) => {
          setshowModal(false);
          toast.success("Group is deleted");
        })
        .catch((err) => {
          setshowModal(false);
          toast.error("Group deletion failed");
        });
    } else return;
  };

  return (
    <>
      <div>
        {groupMeta?.groups?.length === 0 && (
          <button className="confirm-btn" onClick={toggle}>Create Group</button>
        )}
        {!groupMeta?.groups && <Loader width={300} />}
        {groupMeta?.groups?.length >= 1 && (
          <div>
          <div className="topbar">
            <h2 className="title-heading">Groups</h2>
            <button className="add-user-button" onClick={toggle}>+New</button>
          </div>
              <AQCheckinTable
                columns={GroupTableColumns(onDelete, onEdit)}
                data={groupMeta?.groups}
              />
          </div>
        )}
          <ModalForm
            modal={modal}
            toggle={toggle}
            setModal={setModal}
            setshowModal={setshowModal}
            userClickData={userClickData}
            setUserClickData={setUserClickData}
          />
      </div>

      <Modal
        isOpen={showModal}
        toggle={() => setshowModal(!showModal)}
        className="user-modal"
      >
        <AQModal
          nextBtnText={
            <>
              <Button className="confirm-btn" onClick={onConfirm}>
                Yes
              </Button>
            </>
          }
          cancelBtnText={
            <>
              <Button
                className="cancel-btn"
                onClick={() => setshowModal(false)}
              >
                Cancel
              </Button>
            </>
          }
          modal={showModal}
          onConfirm={onConfirm}
          onExitModal={() => setshowModal(!showModal)}
        >
          <span className="user-modal-body">
            Are you sure you want to{" "}
            {userClickData?.type === "delete" && "Delete"} ?
          </span>
        </AQModal>
      </Modal>
    </>
  );
};

export default GroupSetup;
